export const BALANCE_CHANGE = 'users.balance_change';
export const PROFILE_IMAGE_CHANGE = 'users.profile_image_change';
export const HAS_UNREAD_CHAT_MESSAGES = 'realtime.has_unread_chat_messages';
export const CALL_COMING = 'call_coming';
export const CALL_FAILED = 'call_failed';
export const NEW_CHAT_MESSAGE = 'realtime.new_message_for_recipient';
export const AVAILABILITY_CHANGE = 'availability_change';
export const AVAILABILITY_CHANGE_CHAT = 'availability_change_chat';
